<template lang="pug">
include /@ibkr/lib.common/src/icon/basic
include /@ibkr/lib.common/src/icon/color
include /@ibkr/lib.common/src/icon/misc
div(class="border-bottom insety-16 select-regions")
    ib-row
        ib-col(class="xl3")
            p(
                class="insety-16", 
                :class="{'insetx-4': !$media.m, 'insetx-8': $media.l, 'insetx-16': $media.xl}"
            )
                span(
                    class="insetx-3 info", 
                    :class="{'start-0': !$media.m}"
                )
                    +icon-basic-info_filled
                    span(class="tooltext") {{ $t('select_regions') }}
                span {{ $t('regions') }}
        ib-col(
            class="xl9",
        )
            ib-tab-bar(v-model="defaultReg")
                ib-tab2(key="na", class="selectTabs", :class="{tab_style: defaultReg === 'na'}") {{ $t('north_america') }}
                ib-tab2(key="sa", class="selectTabs", v-if="showTab", :class="{tab_style: defaultReg === 'sa'}") {{ $t('south_america') }}
                ib-tab2(key="eu", class="selectTabs", :class="{tab_style: defaultReg === 'eu'}") {{ $t('europe') }}
                ib-tab2(key="ap", class="selectTabs", :class="{tab_style: defaultReg === 'ap'}") {{ $t('asia') }}
                ib-tab2(key="af", class="selectTabs", v-if="showTab", :class="{tab_style: defaultReg === 'af'}") {{ $t('africa') }}
                ib-tab2(key="global", class="selectTabs", v-if="selectedTab === 'exchanges'") {{ $t('global') }}
            div(v-if="defaultReg === 'global'", class="insety-16", :class="{ 'regions' : !$media.xl }")
                ib-button(
                    @click="selectAll('global')",
                    :class="{ active: selectGlobal, fullWidth: !$media.xl }"
                    class="text-left text-bold tab-name after-8",
                ) 
                    span {{ $t('Global') }}
                    span(
                        v-if="selectGlobal",
                        class="inset-8 text-left fg-positive"
                    )
                        +icon-color-yes
            div(v-else-if="defaultReg === 'na'", class="insety-16", :class="{ 'regions' : !$media.xl }")
                ib-button(
                    class="text-left text-bold tab-name after-8",
                    @click="selectAll('na')",
                    :class="{ active: selectNA }"
                )
                    span {{ $t('select_all') }}
                    span(
                        v-if="selectNA",
                        class="inset-8 fg-positive"
                    )
                        +icon-color-yes
                ib-button(
                    v-for="country in NACountries",
                    :key="country.name",
                    :class="{ active: country.selected }",
                    class="text-left tab-name after-8",
                    @click="select(country.value)"
                )
                    span {{ $t(country.name) }}
                    span(
                        v-if="country.selected",
                        class="fg-positive"
                    )
                        +icon-color-yes
            div(v-else-if="defaultReg === 'sa'", class="insety-16", :class="{ 'regions' : !$media.xl }")
                ib-button(
                    class="text-left text-bold tab-name after-8",
                    @click="selectAll('sa')",
                    :class="{ active: selectSA }"
                )
                    span {{ $t('select_all') }}
                    span(
                        v-if="selectSA",
                        class="inset-8 fg-positive"
                    )
                        +icon-color-yes
                ib-button(
                    v-for="country in SACountries",
                    :key="country.name",
                    :class="{ active: country.selected }",
                    class="text-left tab-name after-8",
                    @click="select(country.value)"
                )
                    span {{ $t(country.name) }}
                    span(
                        v-if="country.selected",
                        class="fg-positive"
                    )
                        +icon-color-yes
            div(v-else-if="defaultReg === 'eu'", class="insety-16", :class="{ 'regions' : !$media.xl }")
                ib-button(
                    @click="selectAll('eu')",
                    :class="{ active: selectEU }",
                    class="text-left text-bold tab-name after-8"
                )
                    span {{ $t('select_all') }}
                    span(
                        v-if="selectEU",
                        class="inset-8 fg-positive"
                    )
                        +icon-color-yes
                ib-button(
                    v-for="country in EUCountries",
                    :key="country.id",
                    :class="{ active: country.selected }",
                    class="text-left tab-name after-8"
                    @click="select(country.value)"
                ) 
                    span {{ $t(country.name) }}
                    span(
                        v-if="country.selected",
                        class="fg-positive"
                    )
                        +icon-color-yes
            div(v-else-if="defaultReg === 'ap'", class="insety-16", :class="{ 'regions' : !$media.xl }")
                ib-button(
                    @click="selectAll('ap')",
                    :class="{ active: selectAP }",
                    class="text-left text-bold tab-name after-8"
                )
                    span {{ $t('select_all') }}
                    span(
                        v-if="selectAP",
                        class="inset-8 fg-positive"
                    )
                        +icon-color-yes
                ib-button(
                    v-for="country in APCountries",
                    :key="country.id",
                    :class="{ active: country.selected}",
                    class="text-left tab-name after-8"
                    @click="select(country.value)"
                ) 
                    span {{ $t(country.name) }}
                    span(
                        v-if="country.selected",
                        class="fg-positive"
                    )
                        +icon-color-yes
            div(v-else-if="defaultReg === 'af'", class="insety-16", :class="{ 'regions' : !$media.xl }")
                ib-button(
                    @click="selectAll('af')",
                    :class="{ active: selectAF }",
                    class="text-left text-bold tab-name after-8"
                )
                    span {{ $t('select_all') }}
                    span(
                        v-if="selectAF",
                        class="inset-8 fg-positive"
                    )
                        +icon-color-yes
                ib-button(
                    v-for="country in AFCountries",
                    :key="country.id",
                    :class="{ active: country.selected}",
                    class="text-left tab-name after-8"
                    @click="select(country.value)"
                ) 
                    span {{ $t(country.name) }}
                    span(
                        v-if="country.selected",
                        class="fg-positive"
                    )
                        +icon-color-yes

</template>

<script>
import cloneDeep from 'lodash.clonedeep';
import { mapState, mapActions, mapGetters } from 'vuex';

export default {
    name: 'SelectRegions',
    components: {

    },
    data() {
        return {
            region: 'global',
            domains: ["uk", "ie", "hu", "au", "in"],
        }
    },
    mounted() {
        if(this.$route.params.region != undefined && this.status === 'selected'){
            console.debug("region param change");
            this.setDefaultRegion(this.$route.params.region);
            if((this.showTab === true && ['sa', 'af'].includes(this.$route.params.region)) || ['global', 'na', 'eu', 'ap'].includes(this.$route.params.region)){
                this.selectAll(this.$route.params.region);
                // this.setDefaultRegion(this.$route.params.region);
            } else {
                this.select(this.$route.params.region);
            }
        }
    },
    watch: {
        '$route.params.region'(to, from){
            if(to != undefined){
                if((this.showTab === true && ['sa', 'af'].includes(to)) || ['global', 'na', 'eu', 'ap'].includes(to)){
                    this.selectAll(to);
                    this.setDefaultRegion(to);
                } else {
                    this.select(to);
                }
            }
        },
    }, 
    methods: {
        selectAll(region){
            let selected;
            switch(region) {
                case 'global':
                    selected = !this.selectGlobal;
                    break;
                case 'na':
                    selected = !this.selectNA;
                    break;
                case 'sa':
                    selected = !this.selectSA;
                    break;
                case 'eu':
                    selected = !this.selectEU;
                    break;
                case 'ap':
                    selected = !this.selectAP;
                    break;
                case 'af':
                    selected = !this.selectAF;
                    break;
            }

            const regions = cloneDeep(this.regions);
            regions.forEach(item => {
                if (item.region === region) {
                    item.selected = selected;
                    if(item.selected === true){
                        this.$store.commit('setSelectedRegion', item.value);
                    } else {
                        this.$store.commit('removeSelectedRegion', item.value);
                    }
                } else {
                    if(item.selected === true){
                        this.$store.commit('removeSelectedRegion', item.value);
                    }
                    item.selected = false;
                }
            })
            
            this.setRegions(regions);
        },
        select(value) {
            const index = this.regions.findIndex(item => item.value === value.toUpperCase());
            const region = cloneDeep(this.regions[index]);
            region.selected = !region.selected;
            this.setRegion({index, region});
            
            let nameIndex = this.selectedRegion.indexOf(value.toUpperCase());
            if(nameIndex > -1){
                this.$store.commit('removeSelectedRegion', value.toUpperCase());
            } else {
                this.$store.commit('setSelectedRegion', value.toUpperCase());
            }
            this.setDefaultRegion(region.region);
        },
        ...mapActions(['setRegion', 'setRegions','setDefaultRegion', 'setSelectedRegion', 'removeSelectedRegion'])
    },
    computed: {
        NACountries: function() {
            return this.regions.filter(item => item.region === 'na');
        },
        SACountries: function() {
            return this.regions.filter(item => item.region === 'sa');
        },
        EUCountries: function() {
            return this.regions.filter(item => item.region === 'eu');
        },
        APCountries: function() {
            return this.regions.filter(item => item.region === 'ap');
        },
        AFCountries: function() {
            return this.regions.filter(item => item.region === 'af');
        },
        OCCountries: function() {
            return this.regions.filter(item => item.region === 'oc');
        },
        selectGlobal: function() {
            let checkSelection = this.regions.filter(item => item.name === 'global').map(item => item.selected);
            return checkSelection[0];
        },
        selectNA: function() {
            return this.regions.filter(item => item.region === 'na').length === this.regions.filter(item => item.region === 'na').filter(item => item.selected).length;
        },
        selectSA: function() {
            return this.regions.filter(item => item.region === 'sa').length === this.regions.filter(item => item.region === 'sa').filter(item => item.selected).length;
        },
        selectEU: function() {
            return this.regions.filter(item => item.region === 'eu').length === this.regions.filter(item => item.region === 'eu').filter(item => item.selected).length;
        },
        selectAP: function() {
            return this.regions.filter(item => item.region === 'ap').length === this.regions.filter(item => item.region === 'ap').filter(item => item.selected).length;
        },
        selectAF: function() {
            return this.regions.filter(item => item.region === 'af').length === this.regions.filter(item => item.region === 'af').filter(item => item.selected).length;
        },
        defaultReg: {
            get: function() {
                return this.defaultRegion;
            },
            set: function(newValue) {
                this.setDefaultRegion(newValue);
            }
        },
        showTab: function() {
            if(this.domains.includes(this.selectedDomain)){
                return true;
            } else {
                false;
            }
        },
        ...mapGetters(['selectedDomain']),
        ...mapState(['regions','defaultRegion','selectedRegion', 'selectedTab', 'status'])
    }
}

</script>
<style lang="less">
    .select-regions {
        button {
            border-radius: 0;
            &::after {
                background-color: white;
            }
            svg {
                float: right;
            }
            &:hover {
                border-color: #000;
                .fg-positive {
                    color: #000;
                }
            }
        }
    }
    .tab-name {
        min-width: 27%;
        &.asia {
            min-width: 45%;
        }
    }
    .selectTabs {
        color: black !important;
    }
    button {
        border-radius: 0;
        font-size: 0.875rem;
        &::after {
            background-color: #fff;
            opacity: 0;
        }
        svg {
            float: right;
        }
    }
    .tab_style {
        border-bottom-color: #D91222;
    }
    .regions {
        display: flex;
        flex-direction: column;
        align-items: stretch;
        flex-wrap: wrap;
    }
</style>